import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './OrderList.css';
import Header from './Header';
import SubNav from './SubNav';

function OrderList() {
  const location = useLocation();
  const [startDate, setStartDate] = useState('2024-11-24');
  const [endDate, setEndDate] = useState('2025-12-22');
  const [isLogisticsExpanded, setIsLogisticsExpanded] = useState(true);

  // Determine active menu based on current route
  const getActiveMenu = () => {
    if (location.pathname.startsWith('/scm/')) {
      return 'logistics';
    }
    return 'home';
  };

  const activeMenu = getActiveMenu();

  const handleCalendarClick = (inputId) => {
    const input = document.getElementById(inputId);
    if (input && input.showPicker) {
      input.showPicker();
    }
  };

  const handleMenuClick = (menu) => {
    if (menu === 'logistics') {
      setIsLogisticsExpanded(!isLogisticsExpanded);
    } else {
      setIsLogisticsExpanded(false);
    }
  };

  return (
    <div className="order-list-container">
      <Header activeMenu={activeMenu} onMenuClick={handleMenuClick} />
      {activeMenu === 'logistics' && isLogisticsExpanded && <SubNav />}
      <div className="filterArea">
        <div className="tabButtonArea">
          <button type="button" className="btn default-button">
            다운로드
            <span className="download-icon"></span>
          </button>
          <span className="divider-large"></span>
          <button type="button" className="btn default-button">
            <span className="refresh-icon"></span> 필터초기화
          </button>
          <button type="button" className="btn default-button filterToggle">
            필터
            <span className="up-icon"></span>
          </button>
        </div>

        <form id="searchForm">
          <div className="filterBody">
            <div className="form-row-group">
              <dl className="inline-row">
                <dt>검색조건</dt>
                <dd>
                  <div className="form-row align-items-center">
                    <div className="col-sm-3">
                      <select className="form-control custom-select">
                        <option value="">전체</option>
                        <option value="REQUEST_SEQ">발주번호</option>
                        <option value="VENDOR_ITEM_SEQ">업체상품번호</option>
                        <option value="ITEM_SEQ">쿠팡상품번호</option>
                        <option value="VENDOR_ITEM_NAME">업체상품명</option>
                        <option value="ITEM_NAME">쿠팡상품명</option>
                      </select>
                    </div>
                    <div className="col-sm-6">
                      <input className="form-control" type="text" placeholder="검색어를 입력해주세요" />
                    </div>
                  </div>
                </dd>
              </dl>

              <dl className="inline-row">
                <dt>기간검색</dt>
                <dd className="dateGroup">
                  <div className="form-row align-items-center">
                    <div className="col-sm-3">
                      <select className="form-control custom-select">
                        <option value="REQUEST_DATE">발주일자</option>
                        <option value="WAREHOUSING_PLAN_DATE">입고예정일</option>
                      </select>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-group">
                        <input 
                          className="form-control date-input" 
                          placeholder="시작일" 
                          id="startDateInput" 
                          type="date" 
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                        <span className="input-group-addon" onClick={() => handleCalendarClick('startDateInput')}>
                          <img alt="calendar" src="https://img1a.coupangcdn.com/image/coupang/retail/sc/scm/calendar.png" />
                        </span>
                      </div>
                      <span className="swungDash">~</span>
                      <div className="input-group">
                        <input 
                          className="form-control date-input" 
                          placeholder="종료일" 
                          id="endDateInput" 
                          type="date" 
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                        <span className="input-group-addon" onClick={() => handleCalendarClick('endDateInput')}>
                          <img alt="calendar" src="https://img1a.coupangcdn.com/image/coupang/retail/sc/scm/calendar.png" />
                        </span>
                      </div>
                      <div className="btn-group">
                        <button type="button" className="btn default-button">어제</button>
                        <button type="button" className="btn default-button">오늘</button>
                        <button type="button" className="btn default-button">최근1주</button>
                        <button type="button" className="btn default-button">최근 1달</button>
                      </div>
                    </div>
                  </div>
                </dd>
              </dl>
            </div>

            <div className="form-row-group">
              <dl className="inline-row">
                <dt>입고처</dt>
                <dd>
                  <select className="form-control custom-select">
                    <option value="">전체</option>
                    <option value="CHA12">창원FC</option>
                    <option value="DS01">대구FC</option>
                    <option value="FFF1">파주FC</option>
                    <option value="GYS1">김포FC</option>
                    <option value="MF01">MF01(문정1센터)</option>
                    <option value="MF02">MF02(문정2센터)</option>
                    <option value="MF03">MF03(문정3센터)</option>
                  </select>
                </dd>
              </dl>

              <dl className="inline-row">
                <dt>발주상태</dt>
                <dd>
                  <select className="form-control custom-select">
                    <option value="">전체</option>
                    <option value="REQUESTED">발주완료</option>
                    <option value="PARTIALLY_OUTBOUND">부분반출</option>
                    <option value="OUTBOUND_COMPLETED">반출완료</option>
                    <option value="PARTIALLY_WAREHOUSED">부분입고</option>
                    <option value="WAREHOUSED">입고완료</option>
                    <option value="CANCELLED">발주취소</option>
                  </select>
                </dd>
              </dl>
            </div>
          </div>

          <div className="tabButtonArea">
            <button type="submit" className="btn btn-primary">검색</button>
          </div>
        </form>

        <div className="scmTableArea">
          <table className="scmTable basic">
            <thead>
              <tr>
                <th>발주번호</th>
                <th>발주일자</th>
                <th>입고예정일</th>
                <th>입고처</th>
                <th>업체상품번호</th>
                <th>업체상품명</th>
                <th>쿠팡상품번호</th>
                <th>쿠팡상품명</th>
                <th>발주수량</th>
                <th>반출수량</th>
                <th>입고수량</th>
                <th>발주상태</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="center">PO-2024-001</td>
                <td className="center">2024-12-15</td>
                <td className="center">2024-12-20</td>
                <td className="center">MF01</td>
                <td className="center">VSKU-001</td>
                <td>샘플 업체상품명 1</td>
                <td className="center">12345678</td>
                <td>샘플 쿠팡상품명 1</td>
                <td className="right">100</td>
                <td className="right">100</td>
                <td className="right">95</td>
                <td className="center">부분입고</td>
              </tr>
              <tr>
                <td className="center">PO-2024-002</td>
                <td className="center">2024-12-14</td>
                <td className="center">2024-12-19</td>
                <td className="center">CHA12</td>
                <td className="center">VSKU-002</td>
                <td>샘플 업체상품명 2</td>
                <td className="center">87654321</td>
                <td>샘플 쿠팡상품명 2</td>
                <td className="right">200</td>
                <td className="right">200</td>
                <td className="right">200</td>
                <td className="center">입고완료</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="paginationArea">
          <ul className="scmPaginate">
            <li className="prev"><a href="#">이전</a></li>
            <li className="active"><a href="#">1</a></li>
            <li><a href="#">2</a></li>
            <li><a href="#">3</a></li>
            <li><a href="#">4</a></li>
            <li><a href="#">5</a></li>
            <li className="next"><a href="#">다음</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default OrderList;
